/* eslint-disable prettier/prettier -- behoud de afgesproken witregels binnen conditionals. */
import React, { useEffect } from 'react'

const CaptureComponent = ({ canvas, onCapture, viewerReady }) => {
  useEffect(() => {
    if (viewerReady && onCapture && canvas) {
      const captureCanvas = () => {
        if (!canvas.current) {

          return

        }

        const dataURL = canvas.current.toDataURL('image/png')

        onCapture(dataURL)
      }

      const frame = requestAnimationFrame(captureCanvas)

      // voorkom een late capture nadat de viewer gesloten of vervangen is.
      return () => cancelAnimationFrame(frame)
    }
  }, [viewerReady, onCapture, canvas])

  return null
}

export default CaptureComponent
